import { MoneyAddIcon } from "@xola/icons";
import { almostZero } from "@xola/ui-kit";
import { isArray } from "lodash";
import React from "react";
import { Audit, LineItemType, Purchase, PurchaseItem } from "types";
import { Currency } from "../../../Common/Currency";
import { TimelineItem, TimelineItemReason } from "../TimelineItem";

interface AdjustBalanceTimelineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audit: Audit;
    showDate?: boolean;
}

// This is used to adjust balance for gift
export const AdjustBalanceTimelineItem = ({
    purchase,
    item,
    audit,
    showDate = false,
}: AdjustBalanceTimelineItemProps) => {
    const [amount, reason] = getAmount(item, audit);
    if (!AdjustBalanceTimelineItem.supportsAudit(purchase, item, audit)) {
        return null;
    }

    return (
        <TimelineItem
            title="Adjust Balance"
            audit={audit}
            icon={<MoneyAddIcon />}
            color={amount > 0 ? "success" : "danger"}
            showDate={showDate}
            purchase={purchase}
        >
            <div className="space-y-2">
                <Currency shouldRemoveTrailingZeroes={false}>{amount}</Currency>
                <TimelineItemReason>{reason}</TimelineItemReason>
            </div>
        </TimelineItem>
    );
};

AdjustBalanceTimelineItem.supportsAudit = (_purchase: Purchase, item: PurchaseItem, audit: Audit) => {
    const [amount] = getAmount(item, audit);
    return !almostZero(amount);
};

const getAmount = (item: PurchaseItem, audit: Audit): [number, string] => {
    if (!audit.data?.items) {
        return [0, ""];
    }

    const auditItem =
        isArray(audit.data?.items) && audit.data.items.find((auditItem: any) => auditItem.id === item?.id);

    if (!auditItem) {
        return [0, ""];
    }

    const values: any = Object.values(auditItem.lineItems ?? {});
    for (const value of values) {
        if (value.old === null && value.new.type === LineItemType.ADJUSTMENT && value.new.includeInAmount === false) {
            return [value.new.amount, value.new.name];
        }
    }

    return [0, ""];
};
